<template>
  <div id="v3AlertRoot">
    <div id="v3AlertContainer">
      <div style="font-weight: bold;font-size: medium;display: flex;flex-direction: row;justify-content: center;align-items: center;position: relative;height: 30px;">
        提示
      </div>
      <div id="v3ComfirmAlertMessageTagParent">
        <span :style="{'font-size': $store.state.v3AlertMessageSize, 'paddingLeft':'20px', 'paddingRight':'20px'}" v-for="(contentItem,index) in handleAlertMessage($store.state.alertMessage)" :key="contentItem" :index="index+''">
          {{contentItem}}
        </span>
      </div>
      <HR style="border:1 dashed #987cb9" width="98%" color=lightgray SIZE=1></HR>
      <div style="height:20px;width:100%;display: flex;justify-content: center;align-items: center;color: red;font-size: x-small;" @click="hideAlertPage()">确 认</div>
    </div>
  </div>
 </template>
 
 <script>
  export default {
    data () {
      return {}
    },
    components: {
    },
    methods:{
      // 隐藏提示页面
      hideAlertPage(){
        this.$store.commit('switchAlert', {"showOrHide": false, "alertMessage": "无"})
      }
    },
    computed:{
      handleAlertMessage(){
        return content =>{
          if (content.includes('<br/>')) {
            let newarr = content.split("<br/>")
            // console.log("解析出来的数组", newarr);
            return newarr
          }
          return [content]
        }
      }
    },
  }
 </script>
 
 <style>
#v3AlertRoot{
    /* display: none; */
  width: 100%;
  height: 70vh;
  /* position: relative; */
    position: fixed;
    top: 30vh;
    left: 0;
  background: rgba(51,51,51,0.5);
  z-index: 2233;
  display: flex;
  justify-content: center;
  align-items: center;
}
#v3AlertContainer{
  width: 70%;
  height: 204px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  background: #fff;
  z-index: 2255;
  border-radius: 10px 10px 10px 10px;
}
  
#v3ComfirmAlertMessageTagParent{
  /* background-color: aqua; */
  width: 100%;
  height: 128px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/AlertConfirm.vue